// Признак «сейчас идёт воспроизведение» — общий для страницы просмотра и хука
// присутствия (useOnlineSocket живёт в AppContent, выше роутера, и о плеере
// ничего не знает).
//
// Модуль-синглтон, а не Redux: Kodik шлёт kodik_player_time_update раз в
// секунду, и dispatch с такой частотой дёргал бы ререндер всего дерева.
//
// Нужно потому, что видимость вкладки — плохая мера присутствия для сайта с
// видео: человек с играющей серией присутствует, даже если ушёл в соседнюю
// вкладку или свернул браузер.

// Событие приходит раз в секунду, так что 10 секунд — большой запас на
// подтормаживание. При этом пауза перестаёт считаться присутствием почти сразу.
const PLAYBACK_TTL_MS = 10_000;

let lastPlaybackAt = 0;

export function markPlaybackActivity() {
  lastPlaybackAt = Date.now();
}

export function isPlaybackActive() {
  return Date.now() - lastPlaybackAt < PLAYBACK_TTL_MS;
}

// Пауза, конец серии или уход со страницы просмотра — снимаем признак сразу,
// не дожидаясь истечения TTL.
export function clearPlaybackActivity() {
  lastPlaybackAt = 0;
}
